import HeaderOnlyLayout from './HeaderOnlyLayout';
import { HeaderOnlyLayoutProps, HeaderOnlyLayoutValueProps } from './types';

export type { HeaderOnlyLayoutProps, HeaderOnlyLayoutValueProps };
export default HeaderOnlyLayout;
